import { Navigation, Phone } from "lucide-react";
import business from "../data/business.json";

export const MobileBar = () => (
    <div
        className="mobile-bar md:hidden bg-[#1a262b]/95 backdrop-blur border-t border-bordo px-3 py-2"
        data-testid="mobile-bar"
    >
        <div className="grid grid-cols-2 gap-2">
            <a className="btn btn-amber" href={business.phone.href} data-testid="mobile-call-btn">
                <Phone className="w-[18px] h-[18px]" /> Chiama / Prenota
            </a>
            <a
                className="btn btn-outline"
                href={business.links.mapsDirections}
                target="_blank"
                rel="noreferrer"
                data-testid="mobile-directions-btn"
            >
                <Navigation className="w-[18px] h-[18px]" /> Indicazioni
            </a>
        </div>
    </div>
);